__turbopack_context__.v({
  "viewport": "index-module__hGBBrq__viewport",
});
